import { Page, PageHeader } from '@cast/shared-layout-ui';

import { FeatureControlSection } from '../feature-control/FeatureControlSection';

export const FeatureControlPage = () => {
  return (
    <Page analytics="Feature Control">
      <PageHeader
        heading="Feature control"
        sx={{
          paddingBottom: '8px',
        }}
      />
      <FeatureControlSection />
    </Page>
  );
};
